import { genreTags } from "@/mocks/movies";

const categories = [
  { icon: "ri-movie-2-line", name: "最新电影", desc: "院线新片与热门影片", href: "#latest" },
  { icon: "ri-tv-2-line", name: "电视剧大全", desc: "国产剧 / 美剧 / 韩剧", href: "#tv" },
  { icon: "ri-award-line", name: "好看的片", desc: "编辑精选口碑片单", href: "#picks" },
  { icon: "ri-heart-3-line", name: "伦理片专区", desc: "家庭与情感现实题材", href: "#ethical" },
  { icon: "ri-bar-chart-2-line", name: "排行榜", desc: "本周热度前 10 名", href: "#ranking" },
  { icon: "ri-question-line", name: "常见问题", desc: "字幕与资源说明", href: "#faq" },
];

export default function GenreNavSection() {
  return (
    <section id="genres" className="w-full px-4 md:px-8 py-12 md:py-16">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        分类导航
      </h2>
      <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
        想直接跳到某个方向，可以从下面的分类入口进入；如果只是想随手挑题材，
        下方的题材标签覆盖了站内最常见的类型。
      </p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((c) => (
          <a
            key={c.name}
            href={c.href}
            className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-100 p-4 md:p-5 hover:border-accent-300 hover:bg-accent-50 transition-colors"
          >
            <span className="w-11 h-11 shrink-0 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-foreground-950 transition-colors">
              <i className={`${c.icon} text-xl`} aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-foreground-950">{c.name}</span>
              <span className="block mt-0.5 text-xs text-foreground-500">{c.desc}</span>
            </span>
            <i
              className="ri-arrow-right-line ml-auto text-foreground-400 group-hover:text-accent-600 group-hover:translate-x-0.5 transition-all"
              aria-hidden="true"
            />
          </a>
        ))}
      </div>

      <h3 className="mt-10 font-heading text-lg font-bold text-foreground-900">题材标签</h3>
      <div className="mt-4 flex flex-wrap gap-2">
        {genreTags.map((tag) => (
          <span
            key={tag}
            className="px-3 py-1.5 rounded-md bg-secondary-50 border border-secondary-200 text-secondary-900 text-sm"
          >
            {tag}
          </span>
        ))}
      </div>
    </section>
  );
}